import { Canvas } from "./canvas.interface";
import { XyCoordinates } from "../xy-coordinates.interface";
import { NavigationMenuConstants } from "../../../../../../components/navigation/navigation-menu.constants";

export function createCanvas(
  screenWidth: number,
  screenHeight: number,
  aspectRatio: number
): Canvas {
  const width = screenWidth - NavigationMenuConstants.width;
  const height = width * aspectRatio;

  const scaleFactor = height < screenHeight ? 1 : screenHeight / height;

  return {
    width: width * scaleFactor * 0.75,
    height: height * scaleFactor * 0.75,
  };
}

export function toXyCoordinates(canvas: Canvas): XyCoordinates {
  return {
    x: canvas.width,
    y: canvas.height,
  };
}
